import * as Types from './mutation-types'
import { API_STATES } from '@/helpers'
import storage from '@/modules/storage'
import { merge, isNumber } from 'lodash'
 
const mutations = {
  [Types.SET_TOKEN] (state,token) {
    storage.set('accessToken',token)
    state.accessToken = token
  },

  [Types.APP_LOAD_BEGIN] (state) {
    state.appLoadingState = API_STATES.REQUEST_PENDING
  },
  [Types.APP_LOAD_SUCCESS] (state, { SP,userPermissions } ) {
    state.User = SP.User
    state.Company = SP.Company
    state.Store = SP.Store
    state.assignedStoreIds = SP.assignedStoreIds
    state.userPermissions = userPermissions
    state.appLoadingState = API_STATES.REQUEST_SUCCESS
    state.companyStores = SP.CompanyStores
    state.companyEmployees=SP.CompanyEmployees
  },
  [Types.APP_LOAD_ERROR] (state,err) {
   
    state.accessToken = null
    state.appLoadingState = API_STATES.REQUEST_ERROR
    state.appLoadingErr = err
  },
  [Types.SET_TOKEN] (state,token) {
    storage.set('accessToken',token)
    state.accessToken = token
  },

  [Types.APP_MERGE_OBJECT] (state,{ key,object }){
    state[key] = merge(state[key],object)
  },
  
  [Types.UPDATE_COMPANY_BEGIN](state) {
    state.updateCompanyState = API_STATES.REQUEST_PENDING;
  },
  [Types.UPDATE_COMPANY_SUCCESS](state){
    state.updateCompanyState = API_STATES.REQUEST_SUCCESS
    state.updateCompanyError = null
  },
  [Types.UPDATE_COMPANY_ERROR](state, err) {
    state.updateCompanyState = API_STATES.REQUEST_ERROR
    state.updateCompanyError = err
  },
  [Types.SHOW_FORM](state, { formData = {}, namespace }){
    state.formData = formData
    state.openedForms.push(namespace)
  },
  [Types.HIDE_FORM](state) {
    state.openedForms = []
    state.selectedRecordId = state.formData.id
    state.formData = {}
  },
  [Types.SHOW_DELETE_POPUP](state, { id, namespace }){
    state.selectedRecordId = isNumber(id) ? id : state.selectedRecordId
    state.openedDeletePopups.push(namespace)
  },
  [Types.HIDE_DELETE_POPUP](state) {
    state.selectedRecordId = null
    state.openedDeletePopups = []
  },
  [Types.SET_FORM_DATA](state, data) {
    state.formData = data
  }
}

export default mutations
